/**
 * The refusal the SERVER sends when Classic owns an account, so the login screens can render it as
 * words instead of a code (SMOR-1241).
 *
 * There is deliberately NO domain check in here any more, and no predicate for the browser to call.
 * Whether Smore may sign somebody in depends on whether their account has actually been synced to
 * Classic, which lives on the account record — the browser cannot know it from a typed address. A
 * client-side domain check would have refused every pwcs.edu visitor from the day this shipped,
 * weeks before anybody was migrated. Asking the server as the user types would be accurate but
 * would tell any anonymous visitor which addresses have Smore accounts.
 *
 * So the server decides on submit and answers with `CLASSIC_DOMAIN_ERROR_CODE`; these two constants
 * are only how that answer becomes a sentence. The rule itself lives in
 * `smore/services/classic_domain_block.py`.
 *
 * The same holds for the PWCS emergency lock's refusal, `PWCS_EMERGENCY_LOCK_ERROR_CODE` below: while
 * an engineer has the lock on, every door refuses a PWCS person with it, and the rule lives in
 * `smore/services/pwcs_emergency_lock.py`.
 */

/** Mirrors CLASSIC_DOMAIN_ERROR_CODE in the python guard — change them together. */
export const CLASSIC_DOMAIN_ERROR_CODE = "classic_domain_only";

/** Mirrors BLOCKED_MESSAGE in the python guard — change them together. */
export const CLASSIC_DOMAIN_MESSAGE = "This email is managed by SchoolStatus Classic. Please access Smore through SchoolStatus Classic.";

/** Mirrors PWCS_EMERGENCY_LOCK_ERROR_CODE in smore/services/pwcs_emergency_lock.py — change them together. */
export const PWCS_EMERGENCY_LOCK_ERROR_CODE = "pwcs_emergency_lock";

/** Mirrors PWCS_EMERGENCY_LOCK_MESSAGE in the python module — change them together. */
export const PWCS_EMERGENCY_LOCK_MESSAGE =
  "Smore is temporarily unavailable for Prince William County Public Schools. Please try again later.";
